export default __webpack_public_path__ + "static/media/products-active.7aa66a7e.svg";